"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChannelUnavailable = exports.ChannelUnavailableHeaderText = exports.ChannelUnavailableHeader = void 0;
const React = __importStar(require("react"));
const styled_1 = __importDefault(require("@emotion/styled"));
const theme_1 = __importDefault(require("../styles/theme"));
const HelpLink_1 = require("../help-link/HelpLink");
const BorderWrapper = styled_1.default.div `
	border-top: 1px solid ${theme_1.default.colours.neutral.light};
	padding: 20px ${theme_1.default.layout.spacing.standard};
	&:last-child {
		border-bottom: 1px solid ${theme_1.default.colours.neutral.light};
	}
	@media only screen and (min-width: 768px) {
		padding: 20px ${theme_1.default.layout.spacing.xLarge};
	}
`;
const HeadingWrapper = styled_1.default.div `
	box-sizing: border-box;
	display: flex;
	justify-content: space-between;
	${({ open, hasChildren }) => open && hasChildren && 'padding-bottom: 20px;'};
`;
exports.ChannelUnavailableHeader = styled_1.default.div `
	position: relative;
	display: flex;
	width: 100%;
	${({ role }) => role === 'button' && 'cursor: pointer;'};
`;
exports.ChannelUnavailableHeaderText = styled_1.default.div `
	display: flex;
	flex-direction: column;
	justify-content: center;
	${({ icon }) => icon && 'margin-left: 20px;'};

	> div:first-of-type {
		${theme_1.default.typography.c1};
	}

	> div:last-of-type {
		${theme_1.default.typography.b1};
	}
`;
const Chevron = styled_1.default.div `
padding-right: 10px;
	&:after {
		position: absolute;
		right: 10px;
		font-size: 40px;
		content: "\\e902";
		font-family: ${theme_1.default.typography.fonts.icons};
		${({ open }) => !open && 'transform: rotate(180deg);'};
		color: ${theme_1.default.colours.neutral.darker};
	}
`;
const ExpandWrapper = styled_1.default.div `
	display: flex;
	margin-bottom: 20px;
	${theme_1.default.typography.b1};
`;
const ChannelUnavailable = ({ heading, subheading, children, icon, link, }) => {
    const [open, setOpen] = React.useState(false);
    return (React.createElement(BorderWrapper, { "data-testid": "channel-unavailable" },
        React.createElement(HeadingWrapper, { open: open, hasChildren: !!children },
            React.createElement(exports.ChannelUnavailableHeader, { "data-testid": "accordion-header", role: "button", onClick: () => setOpen(!open) },
                icon && icon(),
                React.createElement(exports.ChannelUnavailableHeaderText, { icon: icon },
                    React.createElement("div", null, heading),
                    React.createElement("div", null, subheading)),
                React.createElement(Chevron, { open: open }))),
        open && (React.createElement(React.Fragment, null,
            React.createElement(ExpandWrapper, null,
                React.createElement("div", null, children)),
            link && React.createElement(HelpLink_1.HelpLink, { to: link }, `Learn more about ${heading}`)))));
};
exports.ChannelUnavailable = ChannelUnavailable;
//# sourceMappingURL=ChannelUnavailable.js.map